import {ButtonHTMLAttributes, FC, ReactNode} from "react";

import {useAudio} from "~/contexts/audio/AudioContext";

interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

const CustomButton: FC<CustomButtonProps> = ({
  children,
  onMouseEnter,
  onTouchStart,
  onClick,
  ...rest
}) => {
  const {playHover, playClick} = useAudio();

  return (
    <button
      onMouseEnter={(e) => {
        playHover();
        if (onMouseEnter) onMouseEnter(e);
      }}
      onTouchStart={(e) => {
        playHover();
        if (onTouchStart) onTouchStart(e);
      }}
      onClick={(e) => {
        playClick();
        if (onClick) onClick(e);
      }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default CustomButton;
